module.exports = __webpack_public_path__ + "img/calidad_msh.968f5a7a.jpg";